export default "__VITE_ASSET__D$x8_lKe__"